<label class="switch">
    <input type="checkbox" [(ngModel)]="value" (change)="switched(value)">
    <span class="slider"></span>
</label>
